import React from "react";
import Link from "@components/Link";
import Title from "@atoms/Title/Title";
import { Box } from "@material-ui/core";
import { useFetchChapterSlug } from "../../hooks";

const ChapterSubLinks = () => {
	const { subLinks, mixLinks } = useFetchChapterSlug();

	if (!subLinks) return <></>;

	return (
		<Box display="flex" flexDirection="column">
			{subLinks.map((item: any) => (
				<Link
					className="HeaderNav--item--link"
					to={`/${item?.slug}`}
					key={item?.slug}
				>
					<Title size="ml" theme="white">
						{item?.subNavLabel}
					</Title>
				</Link>
			))}
			{mixLinks.slice(1, mixLinks.length).map((item: any) => (
				<Link className="HeaderNav--item--link" to={`/${item?.slug}`}>
					<Title size="ml" theme="white">
						{item?.navLabel}
					</Title>
				</Link>
			))}
		</Box>
	);
};

export default ChapterSubLinks;
